import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Loader2, ArrowRight } from "lucide-react";
import { Logo } from "@/components/Logo";
import { UpdateReader } from "@/components/UpdateReader";
import { Button } from "@/components/ui/button";
import api from "@/lib/api";
import { SharedReaderGate } from "@/components/SharedReaderGate";
import { TenXBrandFooter } from "@/components/TenXBrandFooter";

export default function SharedUpdate() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState(false);
  const [access, setAccess] = useState(null);

  const loadContent = async () => {
    const result = await api.get(`/public/shared-updates/${token}`);
    setData(result.data);
  };

  useEffect(() => {
    setData(null); setAccess(null); setError(false);
    api.get(`/public/shared-updates/${token}/access`)
      .then(async ({ data: info }) => { setAccess(info); if (info.verified) await loadContent(); })
      .catch(() => setError(true));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  useEffect(() => {
    const meta = document.createElement("meta"); meta.name = "referrer"; meta.content = "no-referrer";
    document.head.appendChild(meta); return () => meta.remove();
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <header className="sticky top-0 z-20 border-b bg-background/85 backdrop-blur">
        <div className="mx-auto flex max-w-5xl items-center justify-between px-6 py-3">
          <Link to="/" data-testid="shared-logo-link"><Logo /></Link>
          <Button asChild size="sm" variant="outline" className="gap-1.5">
            <Link to="/register" data-testid="shared-cta">Send updates like this <ArrowRight className="h-3.5 w-3.5" /></Link>
          </Button>
        </div>
      </header>

      <main className="mx-auto max-w-5xl px-6 py-10">
        {error ? (
          <div className="mx-auto max-w-md rounded-xl border border-dashed p-10 text-center" data-testid="shared-error">
            <h1 className="h-display text-lg font-semibold text-foreground">This link is no longer available</h1>
            <p className="mt-2 text-sm text-muted-foreground">The update link is invalid or was revoked by the founder.</p>
          </div>
        ) : access?.verification_required && !data ? (
          <SharedReaderGate token={token} access={access} onVerified={loadContent} />
        ) : !data ? (
          <div className="flex items-center justify-center py-20 text-muted-foreground"><Loader2 className="h-6 w-6 animate-spin" /></div>
        ) : (
          <div data-testid="shared-update">
            <div className="mb-6 inline-flex items-center gap-2 rounded-full border bg-secondary/60 px-3 py-1 text-xs font-medium text-muted-foreground">
              Shared investor update · read only
            </div>
            <UpdateReader update={data.update} company={data.company} badge={data.badge} />
          </div>
        )}
      </main>

      <TenXBrandFooter context="shared-update" />
    </div>
  );
}
